/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useCallback } from "react";
import "./index.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import InternalViewAllCard from "../../InternalAccount/InternalViewAllCard/index.jsx";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";

import { setToggle } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { resetToggle } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import Loader from "../../../../components/Loader/Index.jsx";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import { beneInternalViewAllAcc } from "../../../../redux/features/internalApi/internalApi.js";
import {
  addInternalAccLabel,
  removeInternalAccLabel,
} from "../../../../redux/features/InternalAccount/internalAccount";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import {
  enableSwitcher,
  disableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import InternalAccListView from "../InternalAccListViewComponent/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";
import ICONS from "../../../../assets/Icons/index.js";

const InternalAccountViewAll = ({
  id,
  typepop,
  onClosepop,
  handleButtonClick,
  associateAccount,
  associatepanNumber,
  associateaccountNumber,
  setOpenInternalAssociate,
  setOpenBeneAssociate,
  beneAccountId,
  accountType,
  flow,
  setTxnPayLoad,
  txnPayLoad,
  setIsNeft,
  setIsImps,
  setIsRtgs,
  BeneTxnAssocAcct,
  setAssociateModalOpen,
  associateTxn,
  scheduleIntenralTxn,
  remAccount,
  remIFSC,
  remPan,
  typePanBank,
  onCardNavigate,
}) => {
  const location = useLocation();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const navigate = useNavigate();
  const { searchParam, handleSearchParams, handleClearSearchParam } =
    useCustomSearchParams(
      location?.state &&
        location?.state?.approvalStatus &&
        location?.state?.approvalStatus !== "all"
        ? {
            status: location?.state?.approvalStatus,
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          }
        : {
            pageno: GlobalConfiguration.lengthCheckOne,
            pagesize: dropdownOptions[0],
          },
    );
  const convertDate = (dateString) => {
    if (!dateString) return;
    const date = new Date(dateString);
    const timestamp = Math.floor(
      date.getTime() / IntervalConfiguration.intervalMedium,
    );

    return timestamp;
  };
  const dispatch = useDispatch();
  //variable section
  const internalAccount = "internalAccount";
  const updatedStatus = location.state ? location.state.approvalStatus : "";
  const approvalStatus = typepop === "popup" ? "all" : updatedStatus;
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  //useref section
  const dropdownRef = useRef(null);
  const filterRef = useRef(null);
  const dateRef = useRef(null);
  const searchBarRefAcc = useRef(null);
  const searchBarRefAcc2 = useRef(null);
  const searchBarRefAccm = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const searchBarRefAccm2 = useRef(null);
  const scrollContainerRef = useRef(null);
  const lastElementRef = useRef();
  const sidebarRefm = useRef(null);

  //useState section
  const [balanceType, setBalanceType] = useState("Pan");
  const [searchPanText, setSearchPanText] = useState("");
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showSearchBarm, setShowSearchBarm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLabelClicked, setisLabelClicked] = useState(false);
  const [LabelAccounts, setLabelAccounts] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [isLabelPopupOpen, setIsLabelPopupOpen] = useState(false);
  const [LabelSearchText, setLabelSearchText] = useState(
    !associateAccount ? searchParam.get("label")?.split(",") || [] : "",
  );
  const [lableInput, setlableInput] = useState(false);
  const [labels, setLabels] = useState([]);
  const [Labeldata, setLabeldata] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    !associateAccount
      ? searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne
      : GlobalConfiguration.lengthCheckOne,
  );
  const [accumulatedData, setAccumulatedData] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(
    location?.state && !associateAccount
      ? location?.state?.approvalStatus
      : !associateAccount
        ? searchParam.get("status") || ""
        : "",
  );
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarOpenm, setIsSidebarOpenm] = useState(false);
  const [currentCategory, setCurrentCategory] = useState(
    searchParam.get("category") || "",
  );
  const [searchUserText, setSearchUserText] = useState(
    !associateAccount ? searchParam.get("search") || "" : "",
  );
  const [initCategory, setInitCategory] = useState("");
  const [startDateFilter, setStartDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[0]) || "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    convertDate(searchParam.get("date")?.split(",")?.[1]) || "",
  );
  const [accountNumber, setAccountNumber] = useState(
    searchParam.get("accno") || "",
  );
  const [searchIfscText, setSearchIfscText] = useState("");
  const [isIfsc, setIsIfsc] = useState(searchParam.get("ifsc") || "");
  const [panNumber, setPanNumber] = useState(
    searchParam.get("panno") || remPan || "",
  );
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [searchAccountText, setSearchAccountText] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [isStatusSelected, setIsStatusSelected] = useState(false);
  const [selectedValue, setSelectedValue] = useState(
    !associateAccount
      ? searchParam.get("pagesize") || PaginationConfiguration.paginationSmall
      : PaginationConfiguration.paginationSmall,
  );
  const [totalCount, setTotalCount] = useState(0);
  const [mainData, setMainData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState("");
  const [tempEndDate, setTempEndDate] = useState("");
  const [isWheelScrolling, setIsWheelScrolling] = useState(false);
  const [callFilter, setcallFilter] = useState(null);
  const { services } = useSelector((state) => state.refreshToken);
  const [pageSize, setPageSize] = useState(
    !associateAccount
      ? searchParam.get("pagesize") || PaginationConfiguration.paginationSmall
      : PaginationConfiguration.paginationSmall,
  );
  const [getFilterStatus, setFilterStatus] = useState();
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [txnSearchType, setTxnSearchType] = useState("");
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [accountNameValue, setAccountNameValue] = useState("");
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  //Selector section

  const handleSearch = (text) => {
    setSearchUserTextDebounce(text);
    setTxnSearchType("additional");
  };

  const onMount = () => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("AvailableLabelsInternal");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  };
  const { storedPage, toggle } = useSelector(
    (state) => state.beneAllVerification,
  );

  //Write Function section

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleToggle = (newToggleValue) => {
    if (toggle !== newToggleValue) {
      const scrollTarget = scrollContainerRef.current || window;
      scrollTarget.scrollTo({ top: 0, behavior: "smooth" });

      if (!showSearchBar && !isSidebarOpen) {
        dispatch(setToggle(newToggleValue));
      }
    }
  };

  const handleSelect = (value) => {
    handleSubmit("pagesize", value);

    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);

    toggleDropdown();
  };

  const handleFilterCategory = (selectedCategoryName) => {
    setCurrentCategory(selectedCategoryName);
  };

  const handleClickOutside = (event) => {
    if (event.target.className === "internal_acc_black_div") {
      setIsSidebarOpen(false);
    }
    if (sidebarRefm.current && !sidebarRefm.current.contains(event.target)) {
      setIsSidebarOpenm(false);
    }
  };

  const handleKeyDown = useCallback((event) => {
    const activeElement = document.activeElement;
    const isTyping =
      activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA";

    if (
      !isTyping &&
      (event.key.toLowerCase() === "w" ||
        event.key.toLowerCase() === "s" ||
        event.key === "ArrowUp" ||
        event.key === "ArrowDown")
    ) {
      event.preventDefault();
      setIsWheelScrolling(false);
    }
  }, []);

  const handleWheel = useCallback((event) => {
    setIsWheelScrolling(true);
  }, []);

  const getAccStatus = (item) => {
    setCurrentStatus(item);
  };

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      !!(startDateFilter && endDateFilter) ||
        (currentStatus !== "all" && !!currentStatus),
    );
  };

  const handleDateChange = (dates) => {
    if (!dates) {
      setStartDate(null);
      setEndDate(null);
      setStartDateFilter("");
      setEndDateFilter("");
      return;
    }

    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    // Convert Date objects to timestamps (in seconds) for API calls
    if (start && end) {
      const startTimestamp = Math.floor(start.getTime() / 1000);
      const endTimestamp = Math.floor(end.getTime() / 1000);
      setStartDateFilter(startTimestamp);
      setEndDateFilter(endTimestamp);
    } else {
      setStartDateFilter("");
      setEndDateFilter("");
    }
  };

  const handlePagination = (page) => {
    if (filterRef.current) {
      filterRef.current.scrollTop = GlobalConfiguration.lengthCheckZero;
    }
    handleSubmit("pageno", page);
    setLabelAccounts([]);
    setCurrentPage(page);
  };

  const isFilterActive =
    startDateFilter &&
    endDateFilter &&
    startDateFilter !== 0 &&
    endDateFilter !== 0 &&
    !isNaN(Number(startDateFilter)) &&
    !isNaN(Number(endDateFilter));

  const filteredData = accumulatedData;

  //useEffect section
  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    if (isLabelClicked) {
      dispatch(disableSwitcher());
    } else {
      dispatch(enableSwitcher());
    }
  }, [isLabelClicked]);
  useEffect(() => {
    if (callFilter) {
      callFilter();
    }
  }, [balanceType]);

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("wheel", handleWheel, { passive: false });

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("wheel", handleWheel);
    };
  }, [handleKeyDown, handleWheel]);

  const fetchData2 = async () => {
    let data = [];
    setLoadingData(true);

    data = labels
      ?.filter((itm) => {
        if (itm.includes(searchUserTextDebounce)) return itm;
      })
      ?.map((val) => {
        return { id: val, Label: val };
      });
    setInputData(data);
    setLoadingData(false);
  };

  useEffect(() => {
    if (active?.length) {
      fetchData2();
    }
  }, [active, searchUserTextDebounce]);

  async function fetchData() {
    setLoading(true);
    try {
      let queryParams = {
        page_no: currentPage,
        page_size: pageSize,
      };

      const addParamsBasedOnSelection = () => {
        if (currentStatus !== "all") {
          queryParams.approval_status = currentStatus;
        }
        if (currentCategory !== "") {
          queryParams.categoryName = currentCategory;
        }
        if (
          startDateFilter !== "" &&
          endDateFilter !== "" &&
          startDateFilter &&
          endDateFilter &&
          !isNaN(Number(startDateFilter)) &&
          !isNaN(Number(endDateFilter))
        ) {
          queryParams.start_date = startDateFilter;
          queryParams.end_date = endDateFilter;
        }
        if (accountNumber !== "" || remAccount) {
          queryParams.bank_account_no = remAccount ? remAccount : accountNumber;
        }
        if (typePanBank === "BeneAccPanBankSwitch") {
          if (remPan) {
            queryParams.pan = remPan.toUpperCase();
          }
        } else {
          if (panNumber !== "") {
            queryParams.pan = panNumber;
          }
        }
        if (searchUserText !== "") {
          queryParams.search_string = searchUserText;
        }
        if (LabelSearchText?.length !== 0) {
          queryParams.labels = LabelSearchText;
        }
        if (typePanBank === "BeneAccPanBankSwitch") {
          if (remIFSC) {
            queryParams.ifsc = remIFSC.toUpperCase();
          }
        } else {
          if (isIfsc !== "") {
            queryParams.ifsc = isIfsc;
          }
        }

        if (
          internalAccount === "internalAccount" ||
          accountType === "internal" ||
          flow === "internalTxn" ||
          associateTxn === "associateTxn"
        ) {
          queryParams.type = "internalAccount";
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(beneInternalViewAllAcc(queryParams));
      const newData = response?.payload?.internal_accounts || [];
      setMainData(response?.payload);
      setAccumulatedData(newData);
      setTotalCount(
        associateAccount && false
          ? response?.payload?.internal_accounts?.filter((item) => {
              return item?.bank_acc_no !== associateaccountNumber;
            }).length
          : response?.payload?.total_count || 0,
      );

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  }

  useEffect(() => {
    onMount();
  }, [
    currentPage,
    currentStatus,
    currentCategory,
    searchUserText,
    startDateFilter,
    endDateFilter,
    accountNumber,
    pageSize,
    panNumber,
    isIfsc,
    LabelSearchText,
    markerData,
    remAccount,
    remIFSC,
    remPan,
    // associatepanNumber,
  ]);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isSidebarOpen, getFilterStatus]);

  const handleSelectAll = () => {
    const filteredItems = filteredData.filter(
      (item) => item?.approval_status !== "archived",
    );

    const allIds = filteredItems.map((item) => item.id);

    const isAllSelected = allIds.every((id) => LabelAccounts.includes(id));

    if (isAllSelected) {
      setLabelAccounts([]);
    } else {
      setLabelAccounts(allIds);
    }
  };

  useEffect(() => {
    if (isSidebarOpenm) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarOpenm, getFilterStatus]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    currentCategory,
    startDateFilter,
    endDateFilter,
    accountNumber,
    panNumber,
    isIfsc,
    LabelSearchText,
    currentStatus,
  ]);

  // Sync startDate and endDate from timestamps when they exist but Date objects don't
  useEffect(() => {
    if (startDateFilter && endDateFilter && !startDate && !endDate) {
      const start = new Date(
        startDateFilter * IntervalConfiguration.intervalMedium,
      );
      const end = new Date(
        endDateFilter * IntervalConfiguration.intervalMedium,
      );
      setStartDate(start);
      setEndDate(end);
    }
  }, [startDateFilter, endDateFilter]);

  const handleClose = () => {
    setIsLabelPopupOpen(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    fetchData();
    setLabelAccounts([]);
    setisLabelClicked(false);
    setShowSearchBar(false);
    setSearchUserText("");
    setSearchTerm("");
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign, recordIdsFromPopup) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(LabelAccounts);
    const res = await dispatch(
      addInternalAccLabel({ record_ids: recordIds, labels: labelsToAssign }),
    );
    if (addInternalAccLabel.fulfilled.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: "Labels assigned successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalMedium);
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addInternalAccLabel.rejected.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalMedium);
    }
    setLoading(false);
    if (addInternalAccLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (
    labelsToUnassign,
    recordIdsFromPopup,
  ) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds =
      recordIdsFromPopup?.length > GlobalConfiguration.lengthCheckZero
        ? recordIdsFromPopup
        : toArray(LabelAccounts);
    const res = await dispatch(
      removeInternalAccLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeInternalAccLabel.fulfilled.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: "Labels unassigned successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalMedium);
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeInternalAccLabel.rejected.match(res)) {
      setTimeout(() => {
        toast.dismiss();
        CommonToast({
          text: getErrorMessage(res),
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration.intervalMedium);
    }
    setLoading(false);
    if (removeInternalAccLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    dispatch(resetToggle());

    const handleClickOutside = (event) => {
      if (
        searchBarRefAcc.current &&
        !searchBarRefAcc.current.contains(event.target) &&
        searchBarRefAcc2.current &&
        !searchBarRefAcc2.current.contains(event.target)
      ) {
        setShowSearchBar(false);
      }

      if (
        filterRef.current &&
        !filterRef.current.contains(event.target) &&
        !(dateRef.current && dateRef.current.contains(event.target))
      ) {
        setShowDatePicker(false);
      }

      if (
        searchBarRefAccm.current &&
        !searchBarRefAccm.current.contains(event.target) &&
        searchBarRefAccm2.current &&
        !searchBarRefAccm2.current.contains(event.target)
      ) {
        setShowSearchBarm(false);
      }

      if (
        searchBarRefAccm.current &&
        !searchBarRefAccm.current.contains(event.target) &&
        searchBarRefAccm2.current &&
        !searchBarRefAccm2.current.contains(event.target)
      ) {
        setShowSearchBarm(false);
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (approvalStatus && approvalStatus !== "all") {
      setIsStatusSelected(true);
    } else {
      setIsStatusSelected(false);
    }

    // setCurrentStatus(approvalStatus);
    //  setCurrentPage(GlobalConfiguration.lengthCheckOne);

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const clearFilter = () => {
    setInitCategory("");
    handleFilterCategory("");
    setShowDatePicker(false);
    setStartDate(null);
    setEndDate(null);
    setTempEndDate("");
    setTempStartDate("");
    setStartDateFilter("");
    setEndDateFilter("");
    setIsIfsc("");
    setLabelSearchText("");
    setSelectedLabels([]);
    setShowSearchBar(false);
    setisLabelClicked(false);
    setSearchUserText("");
    setSearchTerm("");
    setCurrentStatus("");
    setPanNumber("");

    setIsStatusSelected(false);
    if (accountType !== "internal") {
      setCurrentStatus("");
      getAccStatus(null, "status");
      getAccStatus(null, "approval");
    }

    // if (
    //   (associateAccount ||
    //     BeneTxnAssocAcct ||
    //     accountType === "Internal" ||
    //     associateTxn === "associateTxn") &&
    //   balanceType === "Pan"
    // ) {
    //   setSearchPanText(searchPanText);
    //   setPanNumber(panNumber);
    // } else {
    //   setSearchPanText("");
    //   setPanNumber("");
    // }
    if ((associateAccount || BeneTxnAssocAcct) && balanceType === "Bank") {
      setSearchIfscText(searchIfscText);
      setSearchAccountText(searchAccountText);
      setAccountNumber(accountNumber);
    } else {
      setSearchIfscText("");
      setSearchAccountText("");
      setAccountNumber("");
    }
  };

  const handleSubmit = (key, value) => {
    if (typepop !== "popup") {
      handleSearchParams(key, value);
    }
  };

  return (
    <div
      id="internalAccViewAllContainer"
      className={`bg-primary-bg flex relative flex-col overflow-hidden ${
        typepop === "popup" ? "h-height-full relative" : ""
      }`}
    >
      <div
        className={`bg-primary-bg flex flex-col relative ${
          typepop === "popup" ? "h-height-full" : "h-screen"
        }`}
        style={{
          overflow: isSidebarOpen && "hidden",
        }}
      >
        {isLabelPopupOpen && (
          <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
            <CommonAssignLabelPopup
              headerTitle="Assign/unassign labels:"
              headersubtext="Labels will be used to generate statistics for the associated accounts."
              closehandleFunction={handleClose}
              closeisDisabled={false}
              labels={labels}
              setLabels={setLabels}
              LabelAccounts={LabelAccounts}
              isLabelPopupOpen={isLabelPopupOpen}
              filteredData={(filteredData || []).filter((acc) =>
                Array.isArray(LabelAccounts)
                  ? LabelAccounts.includes(acc?.id)
                  : LabelAccounts === acc?.id,
              )}
              onClose={handleClose}
              loading={loading}
              setLoading={setLoading}
              handleAssignLabels={handleAssignLabelsProp}
              handleUnassignLabels={handleUnassignLabelsProp}
              type="viewall"
            />
          </div>
        )}
        {(isPopoverOpen || isSidebarOpen || showInnerSearchBar) && (
          <div className="acc_black_div"></div>
        )}

        {/* ======= */}
        <div
          className="internal_account_div_container flex-col "
          style={{
            transition: showSearchBar
              ? "all  var(--animation-fast) ease-in"
              : "all  var(--animation-fast) ease-in",
            top: typepop === "popup" ? "var(--bottom-sm)" : "var(--top-base)",
            borderTopRightRadius:
              typepop === "popup"
                ? "var(--border-radius-md)"
                : "var(--border-none)",
            borderTopLeftRadius:
              typepop === "popup"
                ? "var(--border-radius-md)"
                : "var(--border-none)",
            width: "var(--width-full)",
            zIndex:
              typepop === "popup"
                ? "var(--z-index-tooltip)"
                : "var(--z-index-overlay)",
          }}
        >
          <div
            className={` ${typepop === "popup" ? "" : "h-navbar-height mb-margin-xl"} z-z-index-header w-full hidden Qsmd:block `}
          ></div>
          <div
            className={`bene_div_container z-z-index-header Qmd:shadow-box-shadow-bottom Qmd:bg-primary-nav bg-primary-nav-act ${typepop === "popup" ? " w-full Qmd:w-full-popup-width" : "w-full-width"} relative `}
          >
            <TopNavComponent
              topNavCtaBtn1Needed={false}
              topNavCtaBtn1Props={
                isLabelClicked
                  ? {
                      btnText: `${LabelAccounts?.length ? "Clear" : "Cancel"}`,
                      btnType: "button",
                      enabledBgColor: "var(--primary-nav-act)",
                      handleFunction: (e) => {
                        const textContent = e.target.textContent.trim();
                        if (textContent === "Clear") {
                          setLabelAccounts([]);
                        }
                        if (textContent === "Cancel") {
                          setisLabelClicked(false);
                        }
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: isSidebarOpen || showSearchBar,
                      hoverOption: "white",
                    }
                  : undefined
              }
              topNavCtaBtn2Needed={false}
              topNavCtaBtn2Props={
                isLabelClicked
                  ? {
                      btnText: "Assign labels",
                      btnType: "button",
                      enabledBgColor: LabelAccounts?.length
                        ? "var(--text-primary)"
                        : "var(--text-disabled)",
                      handleFunction: (e) => {
                        e.stopPropagation();
                        if (LabelAccounts?.length) {
                          setIsLabelPopupOpen(true);
                        }
                      },
                      enabledTextColor: LabelAccounts?.length
                        ? "var(--primary-bg)"
                        : "Var(--text-primary)",
                      isDisabled:
                        isSidebarOpen ||
                        showSearchBar ||
                        !LabelAccounts?.length,
                      hoverOption: "black",
                      inActiveVariantNeeded: true,
                    }
                  : undefined
              }
              BottomSubText={
                isLabelClicked
                  ? "Select accounts to apply labels. These labels will be used to generate statistics for the associated accounts."
                  : undefined
              }
              BottomSubTextVaraint="primary"
              isSelectionView={isLabelClicked && true}
              isToggleNeeded={true}
              toggleProps={
                !isLabelClicked
                  ? {
                      title: !toggle ? " List view" : "Grid view",
                      state: toggle,
                      isDisabled: isSidebarOpen || showSearchBar,
                      handleClick: (e) => {
                        if (filterRef.current) {
                          filterRef.current.scrollTop =
                            GlobalConfiguration.lengthCheckZero;
                        }
                        handleToggle(!toggle);
                      },
                    }
                  : undefined
              }
              selectionText={`Account selected - ${LabelAccounts?.length || "0"}`}
              selectionBtnProps={
                isLabelClicked
                  ? {
                      btnText: "Select all",
                      btnType: "button",
                      enabledBgColor:
                        filteredData.filter(
                          (item) => item?.approval_status !== "archived",
                        )?.length === LabelAccounts?.length &&
                        !!LabelAccounts?.length
                          ? "var(--positive-bg)"
                          : "var(--primary-nav-act)",
                      handleFunction: () => {
                        handleSelectAll();
                      },
                      enabledTextColor: "var(--text-primary)",
                      isDisabled: false,
                      hoverOption:
                        filteredData.filter(
                          (item) => item?.approval_status !== "archived",
                        )?.length === LabelAccounts?.length &&
                        !!LabelAccounts?.length
                          ? "black"
                          : "white",

                      icon:
                        filteredData.filter(
                          (item) => item?.approval_status !== "archived",
                        )?.length === LabelAccounts?.length &&
                        !!LabelAccounts?.length
                          ? "https://q2pay.in/new_assets/common/approval/selected_with_green_circle.svg"
                          : "https://q2pay.in/new_assets/common/approval/select_all_with_white_outlined_circle.svg",
                    }
                  : undefined
              }
              assignLabelNeeded={true}
              assignTagNeeded={true}
              assignLabelProps={
                !isLabelClicked
                  ? {
                      handleFunction: () => {
                        if (accountType === "internal") {
                          CommonToast({
                            text: "Action restricted in popup mode.",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--error)",
                          });
                          return;
                        } else if (typepop === "popup") {
                          CommonToast({
                            text: "Action restricted in popup mode.",
                            icon: ICONS?.ERROR_WHITE_CIRCLE,
                            variant: "var(--error)",
                          });
                        } else if (
                          services?.includes("ALabel") &&
                          services?.includes("RLabel")
                        ) {
                          if (isSidebarOpen || showSearchBar) {
                            return;
                          }
                          setisLabelClicked((prev) => {
                            if (prev) {
                              setLabelAccounts([]);
                            }
                            return !prev;
                          });
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "ALabel,RLabel",
                            },
                          });
                        }
                      },
                      isDisabled:
                        accountType === "internal" ||
                        typepop === "popup" ||
                        isSidebarOpen ||
                        showSearchBar,
                      enabledBgColor: "var(--primary-bg)",
                      isLoading: false,

                      hoverOption: "black",
                      buttonRef: null,
                      title:
                        "Labels will be used to generate statistics for the associated accounts",
                    }
                  : undefined
              }
              filteredSearchProps={{
                isSortDisabled: loading,
                isFilterDisabled: loading,
                setShowInnerSearchBar: setShowInnerSearchBar,
                showSearchBar: showSearchBar,
                isSearchDisabled: isSidebarOpen || loading,
                onSearchInput: (val) => handleSearch(val),
                searchText: searchUserTextDebounce,
                searchPlaceholder: "Search internal account",
                filterPlaceholder:
                  "name / contact number / email ID / account ID",
                filterItems: [
                  {
                    name: "Search",
                    isMulti: false,
                    value: searchUserText,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("search", val);
                      setSearchUserText(val);
                    },
                    isDropdown: false,
                    isDisabled: loading,
                  },
                  {
                    name: "Account number",
                    short_name: "Int A/c",
                    isMulti: false,
                    value:
                      typePanBank === "BeneAccPanBankSwitch"
                        ? remAccount
                        : accountNumber,
                    displayValue: accountNameValue?.toLowerCase(),
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("accno", val);
                      setAccountNumber(val);
                    },
                    valueType: "string",
                    isDropdown: false,
                    isDisabled: loading
                      ? true
                      : balanceType === "Bank" &&
                        (associateAccount ||
                          BeneTxnAssocAcct ||
                          associateTxn === "associateTxn") &&
                        "disabled",
                  },
                  {
                    name: "IFSC code",
                    short_name: "IFSC",
                    isMulti: false,
                    value:
                      typePanBank === "BeneAccPanBankSwitch"
                        ? remIFSC
                        : isIfsc.toUpperCase(),
                    setValue: (val) => {
                      handleSubmit("ifsc", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setIsIfsc(val);
                    },
                    valueType: "string",
                    isDropdown: false,
                    isDisabled: loading ? true : false,
                  },
                  {
                    name: "PAN number",
                    short_name: "PAN",
                    isMulti: false,
                    value:
                      typePanBank === "BeneAccPanBankSwitch"
                        ? remPan
                        : panNumber.toUpperCase(),
                    setValue: (val) => {
                      handleSubmit("pan", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setPanNumber(val);
                    },
                    valueType: "string",
                    isDropdown: false,
                    isDisabled:
                      associateAccount ||
                      BeneTxnAssocAcct ||
                      associateTxn === "associateTxn"
                        ? true
                        : false,
                  },

                  {
                    name: "Labels",
                    short_name: "Lab",
                    isMulti: true,
                    value: LabelSearchText,
                    setValue: (val) => {
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleSubmit("label", val);
                      setLabelSearchText(val);
                    },
                    isDropdown: true,
                    valueType: "string",
                    isDisabled: loading ? true : false,
                  },
                ],
                filters: [
                  {
                    name: "Account status",
                    filterType: "dropdown",
                    variant: "single",
                    size: "small",
                    value: currentStatus || "",
                    dropdownPlaceHolder: "Select status",
                    isDisable: false,
                    options: [
                      "approved",
                      "pending",
                      "rejected",
                      "blocked",
                      "archived",
                    ],
                    statusPop: true,
                    handleChange: (val) => {
                      handleSubmit("status", val);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      setCurrentStatus(val);
                    },
                  },
                  {
                    name: "Date range",
                    filterType: "calender",
                    variant: "range",
                    size: "small",
                    value:
                      (startDate && endDate) ||
                      (startDateFilter && endDateFilter),
                    isDisable: false,
                    startDate:
                      startDate ||
                      (startDateFilter
                        ? new Date(
                            startDateFilter *
                              IntervalConfiguration.intervalMedium,
                          )
                        : null),
                    endDate:
                      endDate ||
                      (endDateFilter
                        ? new Date(
                            endDateFilter *
                              IntervalConfiguration.intervalMedium,
                          )
                        : null),
                    handleChange: (date) => {
                      handleSubmit("date", date);
                      setCurrentPage(GlobalConfiguration.lengthCheckOne);
                      handleDateChange(date);
                    },
                  },
                ],
                isFilterClearAllDisabled: !(
                  (startDateFilter && endDateFilter) ||
                  currentStatus !== "" ||
                  loading
                ),
                isSearchClearAllDisabled: !(
                  accountNumber?.length ||
                  isIfsc?.length ||
                  panNumber?.length ||
                  LabelSearchText?.length ||
                  searchUserText?.length ||
                  loading
                ),
                inputData: inputData,
                active: active,
                setActive: setActive,
                loadingData: loadingData,
                loading: loading,
                setLoading: setLoadingData,
                isShowSortBy: false,
                isShowFilter: true,
              }}
              ispagination={
                accumulatedData?.length <= GlobalConfiguration.lengthCheckZero
                  ? false
                  : true
              }
            />
          </div>
        </div>
        {showInnerSearchBar && typepop !== "popup" && (
          <div class="absolute opacity-light-opacity pointer-events-none w-full h-full z-z-index-content Qsmd:z-z-index-header"></div>
        )}
        <div
          ref={scrollContainerRef}
          id={toggle ? "infinityScrollContainerBeneView" : undefined}
          tabIndex={!toggle ? "0" : undefined}
          className={`${
            accumulatedData?.length === GlobalConfiguration.lengthCheckZero ||
            loading
              ? "pb-bottom-base"
              : isLabelClicked
                ? toggle
                  ? "Qsmd:pb-padding-base pb-[var(--topnavbar-min-height)]"
                  : "Qsmd:pb-padding-base pb-[var(--topnavbar-min-height)]"
                : toggle
                  ? ""
                  : ""
          } 
  ${showInnerSearchBar ? "opacity-light-opacity pointer-events-none" : ""}
  ${
    typepop === "popup"
      ? "h-full flex flex-col flex-1 overflow-hidden min-h-1"
      : "infinityScrollContainerAccBeneView h-height-full flex-1 min-h-0"
  }`}
          style={{
            marginBottom: !isWheelScrolling && "var(--margin-base)",
          }}
          onKeyDown={(event) => {
            const blockedKeys = ["w", "s", "W", "S", "ArrowUp", "ArrowDown"];

            if (
              blockedKeys.includes(event.key) ||
              event.code === "KeyS" ||
              event.code === "KeyW"
            ) {
              event.preventDefault();
              if (toggle) event.stopPropagation();
              return false;
            }

            if (toggle) event.stopPropagation();
          }}
        >
          {loading ? (
            <div className="loader-container grid place-items-center w-full h-full">
              <Loader />
            </div>
          ) : !!filteredData?.length ? (
            <div
              style={{
                scrollPaddingTop: "var(--padding-md)",
                scrollPaddingBottom: "var(--padding-md)",
              }}
              className={`scroll flex flex-col items-center min-h-0 h-full-height overflow-y-auto ${
                showInnerSearchBar && "pointer-events-none"
              } w-full ${isSidebarOpen && "overflow-y-hidden"}`}
              ref={filterRef}
            >
              {!toggle ? (
                <InternalViewAllCard
                  id={id}
                  filterRef={filterRef}
                  data={accumulatedData}
                  lastElementRef={lastElementRef}
                  isSidebarOpen={showInnerSearchBar}
                  typepop={typepop}
                  handleButtonClick={handleButtonClick}
                  internalAccount={internalAccount}
                  associateaccountNumber={associateaccountNumber}
                  associateAccount={associateAccount}
                  setOpenInternalAssociate={setOpenInternalAssociate}
                  balanceType={balanceType}
                  setOpenBeneAssociate={setOpenBeneAssociate}
                  showSearchBar={showSearchBar}
                  beneAccountId={beneAccountId}
                  txnPayLoad={txnPayLoad}
                  setTxnPayLoad={setTxnPayLoad}
                  setIsImps={setIsImps}
                  setIsNeft={setIsNeft}
                  onClosepop={onClosepop}
                  setIsRtgs={setIsRtgs}
                  accountType={accountType}
                  BeneTxnAssocAcct={BeneTxnAssocAcct}
                  setAssociateModalOpen={setAssociateModalOpen}
                  associateTxn={associateTxn}
                  flow={
                    flow === "internalTxn" ? "internalTxn" : "Internal_Account"
                  }
                  scheduleIntenralTxn={scheduleIntenralTxn}
                  isLabelClicked={isLabelClicked}
                  setLabelAccounts={setLabelAccounts}
                  LabelAccounts={LabelAccounts}
                  isFilterActive={isFilterActive}
                  setlableInput={setlableInput}
                  Labeldata={Labeldata}
                  setLabeldata={setLabeldata}
                  onCardNavigate={onCardNavigate}
                />
              ) : (
                <InternalAccListView
                  id={id}
                  filterRef={filterRef}
                  data={accumulatedData}
                  isSidebarOpen={showInnerSearchBar}
                  page={currentPage}
                  isPopoverOpen={isPopoverOpen}
                  typepop={typepop}
                  handleButtonClick={handleButtonClick}
                  pageSize={pageSize}
                  internalAccount={internalAccount}
                  associateAccount={associateAccount}
                  setOpenInternalAssociate={setOpenInternalAssociate}
                  balanceType={balanceType}
                  showSearchBar={showSearchBar}
                  beneAccountId={beneAccountId}
                  txnPayLoad={txnPayLoad}
                  setTxnPayLoad={setTxnPayLoad}
                  setIsNeft={setIsNeft}
                  setIsImps={setIsImps}
                  setIsRtgs={setIsRtgs}
                  onClosepop={onClosepop}
                  flow="internalAcc"
                  accountType={accountType}
                  setOpenBeneAssociate={setOpenBeneAssociate}
                  setAssociateModalOpen={setAssociateModalOpen}
                  BeneTxnAssocAcct={BeneTxnAssocAcct}
                  isLabelClicked={isLabelClicked}
                  setLabelAccounts={setLabelAccounts}
                  LabelAccounts={LabelAccounts}
                  isFilterActive={isFilterActive}
                  setlableInput={setlableInput}
                  Labeldata={Labeldata}
                  setLabeldata={setLabeldata}
                  scheduleIntenralTxn={scheduleIntenralTxn}
                  onCardNavigate={onCardNavigate}
                />
              )}
            </div>
          ) : !accumulatedData?.length && !filteredData?.length ? (
            <div
              className={`flex flex-col items-center justify-center m-auto w-full h-full`}
              style={{ overflowY: showSearchBar && "scroll" }}
            >
              <img
                src="https://q2pay.in/new_assets/graphics/no_data/no_data_found.svg"
                alt="No data found"
                className="w-graphic-width-md h-graphic-rectangle-height-md mb-margin-sm"
              />
              <p className="bene-acc-no-beneaccount-text mb-margin-sm">
                No data found.
              </p>
              <PrimaryButton
                enabledBgColor="var(--primary-nav-act)"
                btnText="Clear parameters"
                btnType="button"
                handleFunction={() => {
                  clearFilter();
                  if (toggle) handleClearSearchParam();
                }}
                enabledTextColor="var(--text-primary)"
                hoverOption="white"
              />
            </div>
          ) : (
            <div className="loader-container grid place-items-center w-full h-full">
              <Loader />
            </div>
          )}
        </div>
        {accumulatedData?.length > GlobalConfiguration.lengthCheckZero &&
          !loading && (
            <div
              className={`w-width-full z-z-index-content bg-primary-nav ${
                typepop === "popup"
                  ? "w-width-full Qmd:w-full_popup-width rounded-none Qmd:rounded-b-border-radius-md Qmd:rounded-t-none"
                  : "w-width-full rounded-none"
              } ${(isPopoverOpen || isSidebarOpen) && "pointer-events-none"}`}
            >
              <div
                className={`${
                  accountType === "internal" &&
                  filteredData?.length === GlobalConfiguration?.lengthCheckOne
                    ? "hidden"
                    : `block ${showInnerSearchBar ? "pointer-events-none" : ""}`
                }`}
              >
                <PaginationComponent
                  handleSelect={handleSelect}
                  selectedValue={selectedValue}
                  data={mainData}
                  pageSize={pageSize}
                  dropdownOptions={dropdownOptions}
                  handlePagination={handlePagination}
                  currentPage={currentPage}
                  setIsOpen={setIsOpen}
                  typePopup={typepop === "popup"}
                />
              </div>
            </div>
          )}
      </div>
    </div>
  );
};

export default InternalAccountViewAll;
